// 3rd-party modules
import { useEffect, useState } from 'react';
import parse from 'html-react-parser';

// project modules
import AccountBillings from './billings/AccountBillings';
import AccountKiboshDevices from './kibosh-device/AccountKiboshDevices';
import AccountDetails from './AccountDetails';
import AccountAddresses from './AccountAddresses';
import AccountSubscriptions from './subscriptions/AccountSubscriptions';
import CreateNewSubscription from '../new-subscription-steps/CreateNewSubscription';
import Tab from '../shared/tabstrip/tab';
import TabStrip from '../shared/tabstrip';
import HelpDesk from '../support/help-desk/HelpDesk';

// models
import { Account } from '../../models/account';

type Props = {
  refresh: boolean;
  account: Account;
  preSelectedTab?: string;
  showTabs?: boolean;
  onClose?: () => void;
  onSave?: (account: Account) => void;
};

export default function AccountTabs({ refresh, account, preSelectedTab, showTabs = true, onClose, onSave }: Props) {
  const [currentAccount, setCurrentAccount] = useState<Account>(account);
  const [currentTab, setCurrentTab] = useState<number>(0);
  const abortController = new AbortController();

  useEffect(()=> {
    if (refresh) {
      setCurrentAccount(account);

      if (preSelectedTab) {
        switch (preSelectedTab) {
          case 'details':
            setCurrentTab(0);

            break;
          case 'addresses':
            setCurrentTab(1);

            break;

          case 'kibosh-devices':
            setCurrentTab(2);

            break;
          case 'billing':
            setCurrentTab(3);

            break;
          case 'subscriptions':
            setCurrentTab(4);

            break;
          case 'activation':
            setCurrentTab(5);

            break;
          case 'support':
            setCurrentTab(6);

            break;
          case 'help':
            setCurrentTab(7);

            break;

        }
      }
    }
  }, [refresh]);

  const onCancel = () => {
    abortController.abort();

    if(onClose) onClose();
  };

  const onStepSave = (acc: Account, step: string) => {
    switch (step) {
      case 'details':
        if (!account.accountId) // update currentAccount value on insert
          setCurrentAccount(acc);

        if (onSave)
          onSave(account);

        break;

      default:
        break;
    }
  };

  const renderDocsTab = () => {
    return ( 
      <view data-scroll='' data-adaptive="" data-background="highlight">
        {parse(`
          <iframe
            src="https://kibosh.com/docs-category/home"
            width="100%"
            height="900"
            frameborder="0"
            allowfullscreen="allowfullscreen"
            onLoad={(e) => {
              const iframe = e.target as HTMLIFrameElement;
            }}
          ></iframe>`)}
      </view>
    );
  }




  return (
    <TabStrip
      skipSecondaryTabs={false}
      selectedIndex={currentTab}
      onChange={setCurrentTab}
      id="account-tab"
      showTabs={showTabs}>
      <Tab title='Details'>
        <AccountDetails refresh={refresh} account={currentAccount} onCancel={onCancel} onSave={(acc) => onStepSave(acc, 'details')} />
      </Tab>
      <Tab title='Addresses'>
        <AccountAddresses refresh={refresh} account={currentAccount} onCancel={onCancel} onSave={(acc) => onStepSave(acc, 'addresses')} />
      </Tab>

      <Tab title='Kibosh Devices' disabled={!currentAccount.accountId}>
        {!!currentAccount.accountId &&
          <AccountKiboshDevices refresh={!!currentAccount.accountId} account={currentAccount} onCancel={onCancel} onSave={(acc) => onStepSave(acc, 'routers')} />
        }
      </Tab>
      <Tab title='Billing' disabled={!currentAccount.accountId}>
        {!!currentAccount.accountId &&
          <AccountBillings refresh={!!currentAccount.accountId} account={currentAccount} onCancel={onCancel} onSave={(acc) => onStepSave(acc, 'billings')} />
        }
      </Tab>
      <Tab title='Subscriptions' disabled={!currentAccount.accountId}>
        {!!currentAccount.accountId &&
          <AccountSubscriptions refresh={!!currentAccount.accountId} account={currentAccount} onCancel={onCancel} onSave={(acc) => onStepSave(acc, 'subscriptions')} />
        }
      </Tab>
      <Tab title='Activation' disabled={!currentAccount.accountId}>
        {!!currentAccount.accountId &&
          <CreateNewSubscription hasBackButtonOnFirstStep={false} hasSignup={false} onCancel={onCancel} onSave={() => onStepSave(currentAccount, 'activation')} />
        }
      </Tab>
      <Tab title="Support" >
        <HelpDesk />
      </Tab>
      <Tab title='Help' >
        {renderDocsTab()}
      </Tab>
    </TabStrip>
  );
}
